<template>
  <div id="interviewLoadingBox" v-if="isLoading">
    <!-- Placeholder image or loading indicator -->
    <img
      class="d-none d-md-block mb-4"
      style="opacity: 0.6"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/interviewsPlaceholder.svg"
      alt=""
    />
    <img
      class="d-md-none mb-4"
      style="opacity: 0.6"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/interviewsPlaceholderMobile.svg"
      alt=""
    />
  </div>
  <div v-if="interviews && interviews.length" class="px-5 py-1 rounded-corners-10">
    <div class="text-primary my-3 ml-3">
      <h5 class="font-weight-bolder" style="font-size: x-large">
        Interviews
      </h5>
    </div>

    <div class="splide inerviewsSplide newFeatureSlider" aria-label="Slider for Interviews">
      <div class="sands-article-vueslidercontainer splide__track">
        <div class="splide__list">
          <div
            v-for="(interview, i) in interviews"
            :key="i"
            class="d-flex flex-wrap mb-4 splide__slide"
          >
            <div class="col-8 col-md-4">
              <div class="h-md-100">
                <img
                  v-if="interview.authors[0].avatarSquareSmall.xx"
                  loading="lazy"
                  class="img-cover rounded h-md-100 w-100"
                  :src="interview.authors[0].avatarSquareSmall.xx"
                  alt=""
                />
              </div>
            </div>
            <!-- Second column, containing text content -->
            <div class="col-12 col-md-8">
              <div class="mb-xl-5 mb-2 mb-lg-3">
                <p v-if="interview.subtitle">
                  {{ interview.subtitle }}
                </p>
                <a
                  v-if="interview.slug"
                  @click="appendCourseSlugToCurrentURL(interview.slug)"
                  class="cursorPointer"
                >
                  <h4
                    v-if="interview.name"
                    class="mt-lg-0 my-3 text-primary"
                    style="font-size: larger"
                  >
                    {{ interview.name }}
                  </h4>
                </a>
                <h4 v-if="!interview.slug && interview.name" class="mt-lg-0 my-3">
                  {{ interview.name }}
                </h4>
                <p v-if="interview.abstract">
                  {{ truncatedAbstract(interview.abstract, 150) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from "@splidejs/splide";
import CONCORD_QUERIES from "../../services/concord_queries.js";
import { watch } from "vue";
import useElementVisible from "../../services/elementVisibilityService.js";
import axios_queries from '../../services/axios_queries.js';
export default {
  name: "categoryInterviews",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: false,
      interviews: false,
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      firstTimeInViewport: true,
      interviewsLoadingFuncCall:0,
    };
  },

  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.box1Ref = document.getElementById("interviewLoadingBox");

      if (this.box1Ref) {
        const isVisible = useElementVisible(this.box1Ref);
        if (isVisible && isVisible.value && isVisible.value == true) {
          this.firstTimeInViewport = false;
          this.loadInitialData();
        }

        watch(isVisible, (newValue) => {
          if (this.firstTimeInViewport && isVisible && newValue === true) {
            this.firstTimeInViewport = false;
            this.loadInitialData();
          }
          // Do something when isVisible changes
        });
      }
    }, 500);
  },

  methods: {
    loadInitialData() {

      let interviewsLoadingParams = {
        page: 1,
        pagesize: 2,
        querystring: this.settingsPerm.cat,
        transientKey: this.settingsPerm.cat+'-cat-depending-interviews-vue',
        query:  "cat-depending-interviews-vue",
        url: this.settingsPerm.ajaxUrl+'/wp-content/uploads/catpages/'+this.settingsPerm.cat+'-cat-depending-interviews-vue.json'
      };
      axios_queries.loadPublicData(interviewsLoadingParams).then((concordData) => {
          if (concordData && concordData != null && concordData != undefined && concordData != '') {
                if (concordData.advancedSearch && concordData.advancedSearch.interviews && concordData.advancedSearch.interviews.Articles && concordData.advancedSearch.interviews.Articles.length) {
                  this.displayInterviews(concordData.advancedSearch.interviews.Articles);
              }else{
          this.isLoading = false;
        }
          } else{
          this.isLoading = false;
        }
      })  
    },

    displayInterviews(interviews){
        this.interviews = interviews;
          this.isLoading = false;
          this.mount_splide();
          this.loadMoreData();
    },

    async loadMoreData() {
      // Make an API call to fetch more data
      const nextPage = this.currentPage + 1;
      let variablesForQuery = {
        page: nextPage,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_INTERVIEWS;
      let concordData = await axios_queries.getMoreData(graphqlQuery,variablesForQuery);
        if (
          concordData &&
          concordData.advancedSearch &&
          concordData.advancedSearch.interviews &&
          concordData.advancedSearch.interviews.Articles &&
          concordData.advancedSearch.interviews.Articles.length
        ) {
          const newinterviews = concordData.advancedSearch.interviews.Articles;
          // console.log('New interviews',newinterviews);
          this.interviews = [...this.interviews, ...newinterviews];
          // console.log('interviews',this.interviews);
          this.isLoading = false;
          this.currentPage = nextPage;
          this.mount_splide();
        }
    },

    appendCourseSlugToCurrentURL(slug) {
      const currentURL = window.location.href;
      const updatedURL = currentURL + "/" + slug;
      window.location.href = updatedURL;
    },

    truncatedAbstract(text, length) {
      if (text.length <= length) {
        return text;
      } else {
        return text.substring(0, length) + "...";
      }
    },

    addMovedEventListener() {
      this.splide.on("moved", (newIndex) => {
        const lastCardIndex = newIndex + this.splide.options.perPage;
        // console.log('lastcardindex', lastCardIndex);
        // console.log('lenght', this.interviews.length);

        if (
          lastCardIndex === this.interviews.length - 2 &&
          this.interviews.length > this.metaCount
        ) {
          this.loadMoreData();
        }
      });
    },

    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide(".inerviewsSplide", {
            classes: {
              prev: "splide__arrow--prev xx",
              next: "splide__arrow--next xxx",
              arrow: "splide__arrow xxxx",
            },
            perPage: 2,
            perMove: 1,
            rewindByDrag: true,
            gap: "1rem",
            breakpoints: {
              1024: {
                perPage: 2,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              991: {
                perPage: 1,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              767: {
                perPage: 1,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
            },
            rewind: false,
            pagination: false,
            padding: {
              right: "0rem",
              left: "0rem",
            },
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },
  },
};
</script>